import api from '../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import { changeBodyToForm } from "../../../utils"
import { GET_LICENSE_SALES, GET_LICENSE_SALE, CHANGE_LICENSE_SALE_STATUS } from "./actionTypes";
import { GET_LICENSE_SALES_SUCCESS, GET_LICENSE_SALE_SUCCESS, CHANGE_LICENSE_SALE_STATUS_SUCCESS } from "./mutationTypes"




const state = {
    licenseSales: [],
    ids: [],
    isLoading: false
}



const getters = {
    licenseSalesArray: (state) => state.licenseSales,
    singleLicenseSale: state => id => {
        return state.licenseSales.filter(sale => sale.id == id)[0]
    }
}

const mutations = {
    [GET_LICENSE_SALES_SUCCESS](state, { ids, data }) {
        state.licenseSales = [...data ]
    },
    [GET_LICENSE_SALE_SUCCESS](state, data ) {
        state.licenseSales = [...state.licenseSales.filter(sale => sale.id !== data.id), data]
    },
    [CHANGE_LICENSE_SALE_STATUS_SUCCESS](state, { data }) {
        state.licenseSales = [
            {
                ...state.licenseSales.filter( item => item.id == data.id)[0],
                ...data
            }
        ]
    }
}

const actions = {
    async [GET_LICENSE_SALES]({ commit }) {
        Nprogress.start();
        try {
            const { data } = await api.get("payments/payments")
            commit(GET_LICENSE_SALES_SUCCESS, data)
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    async [GET_LICENSE_SALE]({ commit }, id) {
        Nprogress.start();
        try {
            const { data } = await api.get(`payments/payments/${id}`)
            commit(GET_LICENSE_SALE_SUCCESS, data.data[0])
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    async [CHANGE_LICENSE_SALE_STATUS]({ commit }, { id, value }) {
        Nprogress.start();
        try {
            let fd = new FormData();
            fd.append('_method', 'patch')
            fd.append('opt', `${value}`)
            const { data } = await api.post(`payments/payments/${id}`, fd, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json'
                }
            })
            data.data.status = {
                1: "PAID",
                2: "PENDING",
                3: "REJECTED"
            }[data.data.status]

            commit(CHANGE_LICENSE_SALE_STATUS_SUCCESS, data)
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ ${data.message}`
            })
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    }
}

const somethingWentWrong = (err) => {
    console.table(err)
    Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
    })
}

export default {
    state,
    getters,
    mutations,
    actions
}
